import { Stack, Text } from "@mantine/core"
import { Button } from "@tfg/ui"

type SuccessMessageProps = {
  message: string
  onBack?: () => void
  isLoading: boolean
}

export const SuccessMessage = ({
  message,
  onBack,
  isLoading,
}: SuccessMessageProps) => {
  return (
    <Stack align="center">
      <Text style={{ textAlign: "center" }}>{message}</Text>
      {onBack && (
        <Button disabled={isLoading} onClick={onBack}>
          Back
        </Button>
      )}
    </Stack>
  )
}
